"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledItemNameContainer = exports.StyledFilterLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _QuestionFill = _interopRequireDefault(require("../../icons-react/rebrand/QuestionFill"));
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _Bubble2 = require("../Bubble/Bubble");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FilterLabel = function FilterLabel(_ref) {
  var _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    price = _ref.price,
    currencyCode = _ref.currencyCode,
    name = _ref.name,
    _ref$emptyMessage = _ref.emptyMessage,
    emptyMessage = _ref$emptyMessage === void 0 ? 'нет отелей' : _ref$emptyMessage,
    description = _ref.description,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$subjectToPlural = _ref.subjectToPlural,
    subjectToPlural = _ref$subjectToPlural === void 0 ? 'HOTELS' : _ref$subjectToPlural;
  var hasOffersCount = count > 0;
  var showOffersCount = hasOffersCount && (!disabled || disabled && selected);
  return /*#__PURE__*/_react["default"].createElement(StyledFilterLabel, {
    className: className,
    disabled: disabled,
    selected: selected,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledItemNameContainer, null, /*#__PURE__*/_react["default"].createElement(StyledItemName, null, /*#__PURE__*/_react["default"].createElement("span", null, name), description && !isMobile ? /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    text: description
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, null)) : null)), /*#__PURE__*/_react["default"].createElement(StyledItemInfo, null, showOffersCount ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", null, count), ' ', /*#__PURE__*/_react["default"].createElement("span", null, (0, _pluralizeUtils.pluralizeBySubject)(count, subjectToPlural))), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: price,
    currencyCode: currencyCode,
    prefix: " \u043E\u0442 "
  })) : /*#__PURE__*/_react["default"].createElement("span", null, emptyMessage)));
};
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "FilterLabel__StyledBubble",
  componentId: "sc-g9k756-0"
})(["display:inline;vertical-align:middle;margin-left:4px;", "{display:inline;}"], _Bubble2.InnerWrapper);
var StyledQuestionIcon = (0, _styledComponents["default"])(_QuestionFill["default"]).withConfig({
  displayName: "FilterLabel__StyledQuestionIcon",
  componentId: "sc-g9k756-1"
})(["height:16px;path{fill:var(--grey2);}"]);
var StyledItemNameContainer = exports.StyledItemNameContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemNameContainer",
  componentId: "sc-g9k756-2"
})(["display:flex;"]);
var StyledItemName = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemName",
  componentId: "sc-g9k756-3"
})(["overflow:hidden;text-overflow:ellipsis;"]);
var StyledItemInfo = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemInfo",
  componentId: "sc-g9k756-4"
})([""]);
var StyledFilterLabel = exports.StyledFilterLabel = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledFilterLabel",
  componentId: "sc-g9k756-5"
})(["display:flex;flex-direction:column;gap:2px;overflow:hidden;width:100%;font-size:", "px;line-height:", "px;font-weight:400;color:var(--black);", " ", "{font-size:12px;line-height:14px;color:var(--grey1);}"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 16 : 14;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 20 : 16;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(["color:var(--grey1);opacity:var(--disabled-opacity);"]);
}, StyledItemInfo);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FilterLabel);